import { BookedByOption, Company, CompanyUser, Customer } from '@/types';

export const CUSTOMER_SEARCH_PAGE_SIZE = 100;
export const MAX_CUSTOMER_SEARCH_PAGES = 200;

export const normalizeSearchText = (value: string) =>
  String(value || '')
    .trim()
    .toLowerCase();

export const getCustomerLookupKey = (customer: Customer) =>
  customer.id || normalizeSearchText(customer.email);

// Options for the "Booked By" picker beside the staff portal's company search:
// the company's main contact ('primary') first, then that company's own active
// account holders. Staff book on behalf of any company, so the list is always
// rebuilt from the team of the company currently selected — never a mix.
// The server re-validates the pick against the same company.
export const buildBookedByOptions = (
  company: Company | null | undefined,
  members: CompanyUser[]
): BookedByOption[] => {
  if (!company) return [];

  const options: BookedByOption[] = [
    {
      id: 'primary',
      name: company.contactPerson || company.name,
      email: company.email
    }
  ];

  members.forEach((member) => {
    // Primary rows are already represented by the synthetic 'primary' option above.
    if (!member?.id || member.id === 'primary' || member.isPrimary || member.isActive === false) {
      return;
    }
    options.push({ id: member.id, name: member.name, email: member.email });
  });

  return options;
};
